<template>
  <div class="px-8 py-6" style="height:100dvh; width:100%;overflow-y: auto;">
    <h3>발주입고 현황</h3>
    <FilterModal
      :filterList="filterList"
      :listItems="listItems"
      :statusList="statusList"
      :statusName="'발주상태'"
      :noSend="true"
      :orderInvoice="'Y'"
      @sendFilterData="receiveFilterData"
    />
    <div class="align-center d-flex pb-3 pt-3">
      <div class="pr-5">
        <v-select
          v-resize="updateWindowHeight"
          :items="searchItems"
          item-text="searchText"
          item-value="searchValue"
          solo
          height="26px"
          class="width100-height30 border-5c5c5c"
          flat
          dense
          v-model="searchCategory"
          :menu-props="{ offsetY: true }"
        />
      </div>
      <input
        v-model="searchWord"
        class="cursor-pointer border-5c5c5c back-white width300-height30 mr-3"
        @keyup.enter="startAndReset(1)"
      />
      <v-btn
        color="#3F557D"
        width="78"
        height="30"
        class="color-white mr-3"
        @click="startAndReset(1)"
      >
        <span class="search-text"> 조회</span>
      </v-btn>
      <v-spacer />

      <v-btn
        class="border-btn mr-4 align-center justify-center d-flex"
        width="120"
        height="30"
        @click="$bus.$emit('resultOpen')"
        v-if="userState == '현장관리자' || userState == '시스템관리자'"
      >
        <img src="/static/btn/chartbar.png" class="mr-1" />
        <span class="border-text ">실적조회</span>
      </v-btn>

      <v-btn
        class="border-btn align-center justify-center d-flex"
        width="120"
        height="30"
        @click="excelDown"
        v-if="userState == '현장관리자' || userState == '시스템관리자'"
      >
        <img src="/static/btn/down.png" class="mr-1" />
        <span class="border-text">내려받기</span>
      </v-btn>
    </div>

    <v-simple-table
      ref="tableRef"
      class="width-100 back-fbfbfb col-sticky pt-2"
      fixed-header
      :height="windowInnerHeight - 48 - 260"
      dense
    >
      <thead>
        <tr>
          <th
            class="text-center back-8ca9dd color-white border-right-white first-child1"
            style="width:80px !important;"
          >
            차수
          </th>
          <th
            class="text-center back-8ca9dd color-white border-right-white  first-child2 "
            style="z-index:16 !important"
          >
            부위
          </th>
          <th class="floor-td text-center back-8ca9dd color-white ">
            동
          </th>
          <th
            class="floor-td text-center back-8ca9dd color-white border-left-white "
          >
            층
          </th>
          <th
            class="floor-td text-center back-8ca9dd color-white border-left-white border-right-white "
          >
            부재
          </th>
          <th
            class="text-center back-8ca9dd color-white border-right-white first-child3"
            style="z-index:16 !important"
          >
            구분
          </th>
          <th class="text-center back-8ca9dd color-white">
            일자
          </th>
          <th class="text-center back-8ca9dd color-white border-left-white ">
            출고일자
          </th>
          <th
            class="back-8ca9dd color-white text-center border-left-white"
            v-for="list in materialList"
            :key="list.rebar_id"
          >
            {{ list.rebar_name }}
          </th>
          <th class="text-center back-8ca9dd color-white border-left-white">
            합계
          </th>
          <th class="text-center back-8ca9dd color-white border-left-white">
            반입확인
          </th>
          <th class="text-center back-8ca9dd color-white border-left-white">
            메모
          </th>
        </tr>
        <tr v-if="sumOrderList.length">
          <th
            rowspan="3"
            class="text-center back-cadbf9 border-left-aaaaaa first-child1"
          ></th>
          <th
            rowspan="3"
            class="text-center back-cadbf9  first-child2"
            style="z-index:16 !important"
          ></th>
          <th rowspan="3" :colspan="3" class=" text-center back-cadbf9">
            총합
          </th>
          <th
            rowspan="3"
            class="  text-center back-cadbf9 first-child3"
            style="z-index:16 !important"
          ></th>
          <td
            rowspan="3"
            class=" border-right-aaaaaa text-center back-cadbf9 border-bottom-aaaaaa"
          ></td>
          <th class="border-right-aaaaaa text-center back-ecf3f9">발주</th>
          <th
            v-for="(order, index) in sumOrderList"
            :key="index * 100"
            class="border-right-aaaaaa text-right px-1 back-ecf3f9"
          >
            {{ order == 0 || !order ? "0" : mathRound(order).toFixed(3) }}
          </th>
          <th class="border-right-aaaaaa text-right px-1 back-ecf3f9">
            {{ sum(sumOrderList).toFixed(3) }}
          </th>
          <th colspan="3" rowspan="3"></th>
        </tr>
        <tr v-if="sumInvoiceList.length">
          <th class="border-right-aaaaaa text-center back-ecf3f9">입고</th>
          <th
            v-for="(order, index) in sumInvoiceList"
            :key="index * 102"
            class="border-right-aaaaaa text-right px-1 back-ecf3f9"
          >
            {{ order == 0 || !order ? "0" : mathRound(order).toFixed(3) }}
          </th>
          <th class="border-right-aaaaaa text-right px-1 back-ecf3f9">
            {{ sum(sumInvoiceList).toFixed(3) }}
          </th>
        </tr>
        <tr v-if="sumInvoiceList.length">
          <th
            class="border-right-aaaaaa border-bottom-aaaaaa text-center back-ecf3f9"
          >
            잔량
          </th>
          <th
            v-for="index in sumInvoiceList.length"
            :key="index * 101"
            class="border-right-aaaaaa border-bottom-aaaaaa px-1 text-right back-ecf3f9"
          >
            {{
              sumOrderList[index - 1] - sumInvoiceList[index - 1] == 0
                ? "0"
                : mathRound(
                    sumOrderList[index - 1] - sumInvoiceList[index - 1]
                  ).toFixed(3)
            }}
          </th>
          <th
            class="border-right-aaaaaa border-bottom-aaaaaa text-right px-1 back-ecf3f9"
          >
            {{ mathRound(sum(sumOrderList) - sum(sumInvoiceList)).toFixed(3) }}
          </th>
        </tr>
      </thead>
      <tbody v-for="index in tbodyLength" :key="index * 103">
        <tr>
          <th
            class="text-center border-right-aaaaaa border-left-aaaaaa border-555555"
            :rowspan="tempList[keyList[index - 1]].length + 2"
          >
            <div style="width:78px;">
              {{ tempList[keyList[index - 1]][0].orderName }}
            </div>
          </th>
          <td
            class="text-center border-right-aaaaaa first-child2 border-555555"
            :rowspan="tempList[keyList[index - 1]].length + 2"
          >
            <v-btn
              @click="move(tempList[keyList[index - 1]][0].orderId)"
              color="#0038FF"
              text
              width="228"
              class="text-start"
            >
              {{ tempList[keyList[index - 1]][0].partName }}
            </v-btn>
          </td>
          <td
            class="text-center border-right-aaaaaa border-555555 font-12 px-1"
            :rowspan="tempList[keyList[index - 1]].length + 2"
          >
            {{ tempList[keyList[index - 1]][0].dong }}
          </td>
          <td
            class="text-center border-right-aaaaaa border-555555 font-12 px-1"
            :rowspan="tempList[keyList[index - 1]].length + 2"
          >
            {{ tempList[keyList[index - 1]][0].floor }}
          </td>
          <td
            class="text-center border-right-aaaaaa border-555555 font-12 px-1"
            :rowspan="tempList[keyList[index - 1]].length + 2"
          >
            {{ tempList[keyList[index - 1]][0].type }}
          </td>
          <td class="w-100 text-center border-right-aaaaaa first-child3">
            승인
          </td>
          <td class="w-100 text-center border-right-aaaaaa">
            {{
              tempList[keyList[index - 1]][0].orderRegDate
                | moment("YYYY-MM-DD")
            }}
          </td>
          <td class="w-100 border-right-aaaaaa"></td>
          <td
            class="cnt-td text-right px-1 border-right-aaaaaa"
            v-for="(rebar, v) in tempList[keyList[index - 1]][0].rebarList"
            :key="v * 109"
          >
            {{ rebar == 0 ? "0" : rebar.toFixed(3) }}
          </td>
          <td class="total-cnt-td text-right px-1 border-right-aaaaaa">
            {{
              sumTotalList(tempList[keyList[index - 1]][0].rebarList).toFixed(3)
            }}
          </td>
          <td class="border-right-aaaaaa"></td>
          <td
            :rowspan="tempList[keyList[index - 1]].length + 2"
            class="border-555555"
          >
            <v-btn
              @click="
                memoClick(
                  tempList[keyList[index - 1]][0].orderId,
                  'orderInvoice'
                )
              "
              :color="
                tempList[keyList[index - 1]][0].orderMemo == 'Y'
                  ? '#0038FF'
                  : '#ff0000'
              "
              width="40"
              text
              height="30"
              :disabled="
                tempList[keyList[index - 1]][0].orderMemo == 'Y'
                  ? false
                  : viewerRole
              "
            >
              {{
                tempList[keyList[index - 1]][0].orderMemo == "Y"
                  ? "보기"
                  : "추가"
              }}
            </v-btn>
          </td>
        </tr>
        <tr v-for="i in tempList[keyList[index - 1]].length - 1" :key="i * 104">
          <td class="text-center border-right-aaaaaa min-w-100 first-child3">
            {{ `입고${i}차` }}
          </td>
          <td class="w-100 text-center border-right-aaaaaa ">
            {{
              tempList[keyList[index - 1]][i].completeDate
                | moment("YYYY-MM-DD")
            }}
          </td>
          <td class="w-100 text-center border-right-aaaaaa">
            {{
              tempList[keyList[index - 1]][i].invoiceData | moment("YYYY-MM-DD")
            }}
          </td>
          <td
            class="cnt-td text-right px-1 border-right-aaaaaa "
            v-for="l in materialList.length"
            :key="l * 108"
          >
            {{
              tempList[keyList[index - 1]][i].rebarList[l - 1]
                ? tempList[keyList[index - 1]][i].rebarList[l - 1].toFixed(3)
                : "0"
            }}
          </td>
          <td class="total-cnt-td text-right px-1 border-right-aaaaaa ">
            {{ sumTotalList(tempList[keyList[index - 1]][i].rebarList) }}
          </td>
          <td class="text-center border-right-aaaaaa ">
            {{ tempList[keyList[index - 1]][i].completeDate ? "" : "입고대기" }}
          </td>
        </tr>
        <tr>
          <td class="first-child3"></td>
          <td colspan="2" class="text-center border-right-aaaaaa ">
            반입량 합계
          </td>
          <td
            v-for="(p, d) in totalInvoiceList(tempList[keyList[index - 1]])"
            :key="d * 105"
            class="text-right px-1 border-right-aaaaaa"
          >
            {{ p == 0 ? "0" : mathRound(p).toFixed(3) }}
          </td>
          <td class="text-right px-1 border-right-aaaaaa">
            {{
              sumTotalList(
                totalInvoiceList(tempList[keyList[index - 1]])
              ).toFixed(3)
            }}
          </td>
          <td class="border-right-aaaaaa"></td>
        </tr>
        <tr>
          <td
            class="first-child3 border-bottom-aaaaaa back-fff4ea border-555555"
          ></td>
          <td
            colspan="2"
            class="text-center border-right-aaaaaa border-555555 back-fff4ea"
          >
            잔여 발주량
          </td>
          <td
            v-for="(k, c) in totalList(tempList[keyList[index - 1]])"
            :key="c * 106"
            class="text-right px-1 border-right-aaaaaa border-555555 back-fff4ea"
            :class="
              mathRound(k) == 0
                ? ''
                : mathRound(k) > 0
                ? 'color-red'
                : 'color-blue'
            "
          >
            {{ k == 0 ? "0" : mathRound(k).toFixed(3) }}
          </td>
          <td
            class="text-right px-1 border-right-aaaaaa border-555555 back-fff4ea"
          >
            {{
              mathRound(
                sumTotalList(totalList(tempList[keyList[index - 1]]))
              ).toFixed(3)
            }}
          </td>
          <td
            class="border-right-aaaaaa border-555555 text-center"
            :style="{
              color: checkTotalList(tempList[keyList[index - 1]]).color,
              width: '70px',
            }"
          >
            {{ checkTotalList(tempList[keyList[index - 1]]).name }}
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <div class="mt-3 justify-center pb-4 mb-4">
      <v-pagination
        v-model="page"
        color="#8EB4FA"
        :length="pageLength"
        :total-visible="10"
      ></v-pagination>
    </div>
    <ResultReference
      :totalSumList="totalSumList"
      v-if="userState == '현장관리자' || userState == '시스템관리자'"
    />
  </div>
</template>

<script>
import DatePickerMixin from "@/mixin/DatePicker";
import Search from "@/mixin/Search";
import OrderInvoiceApi from "@/api/OrderInvoiceService";
import FileApi from "@/api/FileService";
import FileDown from "@/assets/js/file-download";
import Commonality from "@/mixin/Commonality";
import Mobile from "@/mixin/Mobile";
import ResultReference from "./modal/ResultReference.vue";
import FilterModal from "@/components/Filter.vue";

export default {
  mixins: [DatePickerMixin, Search, Commonality, Mobile],
  components: {
    ResultReference,
    FilterModal,
  },
  data: () => ({
    dateItems: [
      { searchText: "승인일자", searchValue: 1 },
      { searchText: "출고일자", searchValue: 2 },
      { searchText: "입고일자", searchValue: 3 },
    ],
    searchItems: [
      { searchText: "차수", searchValue: 1 },
      { searchText: "부위", searchValue: 2 },
      { searchText: "동", searchValue: 3 },
      { searchText: "층", searchValue: 4 },
      { searchText: "부재", searchValue: 5 },
    ],
    searchWord: "",
    orderInvoiceList: [],
    orderInvoiceTotalList: [],
    page: 1,
    searchDateCategory: 1,
    searchCategory: 1,
    totalSumList: {},
    tempList: {},
    keyList: [],
    tempTotalList: {},
    sumInvoiceList: [],
    sumOrderList: [],
    sumTotalList1: [],
    tbodyLength: 0,
    orderNameState: "desc",
    partState: null,
    filterModal: false,
    filterList: [],
    methodFilterData: {},
    listItems: [
      { searchText: "승인일자", searchValue: 1 },
      { searchText: "출고일자", searchValue: 2 },
      { searchText: "입고일자", searchValue: 3 },
    ],
    statusList: [
      {
        name: "발주완료",
        status: true,
      },
      {
        name: "출고완료",
        status: true,
      },
      {
        name: "일부입고",
        status: true,
      },
      {
        name: "입고완료",
        status: true,
      },
    ],
    windowInnerHeight: 0,
  }),
  computed: {
    /** 저장된 필터 있는지 여부 */
    isStoreFilter() {
      return this.$store.getters?.getOrderInvoiceFilter;
    },
    viewerRole() {
      return this.$store.getters.getUserList.roleType === "뷰어";
    },
  },

  created() {
    this.$bus.$on("orderInvoiceNavigationDuplicated", () => {
      this.startAndReset(1);
    });
    if (!this.isStoreFilter) {
      this.startAndReset(1);
    }
  },

  beforeDestroy() {
    this.$bus.$off("orderInvoiceNavigationDuplicated");
  },

  watch: {
    orderInvoiceList(val) {
      this.totalSumList = this.totalSumLists(val);
    },
    page(val) {
      this.startAndReset(val);
      this.scrollTop();
    },
  },

  methods: {
    /** table Scroll top 이동함수 */
    scrollTop() {
      const container = this.$refs.tableRef?.$el?.querySelector(
        ".v-data-table__wrapper"
      );
      if (container) {
        container.scrollTop = 0;
      }
    },
    updateWindowHeight() {
      if (typeof window !== "undefined") {
        this.windowInnerHeight = window.innerHeight;
      }
    },
    async searchFilterList(payload) {
      let data = {
        ...payload,
        constructionId: this.constructionId,
      };
      let res = await OrderInvoiceApi.filterListSearch(data);
      this.filterList = res.data;
    },
    orderByOrderInvoice(name) {
      if (this.orderNameState == "asc") {
        this.keyList.sort((a, b) => b - a);
        this.orderNameState = "desc";
      } else {
        this.keyList.sort((a, b) => a - b);
        this.orderNameState = "asc";
      }

      //this.startAndReset();
    },

    async startAndReset(payload) {
      this.$bus.$emit("loadingStart");
      let data = {
        constructionId: this.constructionId,
        keyword: this.searchWord,
        type: this.searchCategory,
        startDate: this.startDate,
        endDate: this.finishDate,
        currentPage: payload ? payload : this.page,
        dateType: this.searchDateCategory,
        pagingCount: 20,
        order: [this.orderNameState, this.partState],
      };
      data = Object.assign(data, this.methodFilterData);
      let orderInvoiceRetrunList = await OrderInvoiceApi.orderinvoiceTotalList(
        data
      );
      this.orderInvoiceTotalList = orderInvoiceRetrunList.data.orderInvoiceList;

      this.searchFilterList(data);
      const groupBy = function(data, key) {
        return data.reduce(function(carry, el) {
          let group = el[key];
          if (carry[group] === undefined) {
            carry[group] = [];
          }
          carry[group].push(el);
          return carry;
        }, {});
      };
      let temps = groupBy(this.orderInvoiceTotalList, "orderName");

      this.tempTotalList = temps;
      this.tempList = temps;
      this.orderInvoiceList = this.orderInvoiceTotalList;
      this.page = orderInvoiceRetrunList.data.pageInfo.currentPage;
      this.pageLength = orderInvoiceRetrunList.data.pageInfo.endPage;
      this.keyList = Object.keys(this.tempList).sort((a, b) => b - a);
      this.tbodyLength = this.keyList.length;
      this.sumInvoiceList =
        orderInvoiceRetrunList.data.orderInvoiceTotalList.totalComplete[0];
      this.sumOrderList =
        orderInvoiceRetrunList.data.orderInvoiceTotalList.totalOrder[0];

      this.$bus.$emit("loadingEnd");
    },

    move(data) {
      this.$router.push({
        name: "OrderinvoiceDetail",
        params: {
          orderId: data,
        },
      });
    },
    /** 엑셀 다운로드 (필터적용) */
    async onClickExcelDown() {
      this.$bus.$emit("loadingStart");
      let data = {
        constructionId: this.constructionId,
        keyword: this.searchWord,
        type: this.searchCategory,
        startDate: this.startDate,
        endDate: this.finishDate,
        dateType: this.searchDateCategory,
      };
      try {
        console.log("엑셀필터-미완성", data);
        // let res = await FileApi.orderInvoiceDown(data);
        // if (res.data.size > 1) {
        //   FileDown(
        //     res.data,
        //     `${this.constructionName.constructionName} 발주입고 현황.xlsx`
        //   );
        // } else {
        //   this.$bus.$emit("dialog", "서버 문제로 잠시후 실행해주세요.");
        // }
      } catch (err) {
        this.$bus.$emit("loadingEnd");
        console.error(err);
      }
      this.$bus.$emit("loadingEnd");
    },
    /** (구) 내려받기 */
    async excelDown() {
      this.$bus.$emit("loadingStart");
      let data = {
        constructionId: this.constructionId,
        keyword: this.searchWord,
        type: this.searchCategory,
        startDate: this.startDate,
        endDate: this.finishDate,
        dateType: this.searchDateCategory,
      };
      data = Object.assign(data, this.methodFilterData);
      try {
        let res = await FileApi.orderInvoiceDown(data);
        if (res.data.size > 1) {
          FileDown(
            res.data,
            `${this.constructionName.constructionName} 발주입고 현황.xlsx`
          );
        } else {
          this.$bus.$emit("dialog", "서버 문제로 잠시후 실행해주세요.");
        }
      } catch (error) {
        this.$bus.$emit("loadingEnd");
      }
      this.$bus.$emit("loadingEnd");
    },

    sumTotalList(list) {
      if (list.length > 0)
        return this.mathRound(
          list.reduce((accumulator, currentValue) => accumulator + currentValue)
        );
      else return 0;
    },

    totalInvoiceList(list) {
      let tempList = [];
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < list[i].rebarList.length; j++) {
          if (list[i].invoiceId && !list[i].completeDate) break;
          if (i == 0) tempList.push(0);
          else {
            tempList[j] += list[i].rebarList[j];
          }
        }
      }
      return tempList;
    },

    totalList(list) {
      let tempList = [];
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < list[i].rebarList.length; j++) {
          if (list[i].invoiceId && !list[i].completeDate) break;
          if (i == 0) tempList[j] = -this.mathRound(list[i].rebarList[j]);
          else
            tempList[j] =
              this.mathRound(tempList[j]) +
              this.mathRound(list[i].rebarList[j]);
        }
      }
      return tempList;
    },
    checkTotalList(list) {
      let tempList = this.totalList(list);
      let totalSum = this.sumTotalList(list[0].rebarList); //총합계
      let balanceTotalSum = this.mathRound(this.sumTotalList(tempList)); //잔여발주량 총합계

      // 1. 일부반입: -0.01(-10kg) 미만 시 /예: -0.011(-11kg) 강종 별 1개라도 포함 시 일부반입
      // 2. 반입완료: -0.01(-10kg) 이상 시 /예: -0.009(-9kg)
      const 일부반입배열 = tempList.filter((temp) => {
        // return temp < 0;
        const remainingOrderQy = this.mathRound(temp); // 강종 별 잔여 발주량(Qy:수량)
        return remainingOrderQy < -0.01;
      });
      if (list.length == 1) return { name: "미반입", color: "#888888" };
      else if (!list[1].completeDate)
        return { name: "미반입", color: "#888888" };
      else if (balanceTotalSum + totalSum <= 0)
        return { name: "미반입", color: "#888888" };
      else if (일부반입배열.length > 0)
        return { name: "일부반입", color: "#FF0000" };
      else if (tempList.filter((temp) => temp >= 0.1).length > 0)
        return { name: "과반입", color: "#FF0000" };
      else return { name: "반입 완료", color: "#37AC00" };
    },

    receiveFilterData(data) {
      this.methodFilterData = data;
      this.searchWord = "";
      this.startAndReset(1);
    },
  },
};
</script>

<style>
button {
  box-shadow: none !important;
}
.back-8ca9dd {
  background: #8ca9dd !important;
}
.v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
  min-height: 28px !important;
}
.back-cadbf9 {
  background: #ecf3f9 !important;
  font-family: "Noto Sans KR";
  font-size: 17px;
  font-weight: 500;
  line-height: 25px;
  letter-spacing: 0em;
  text-align: left;
}
.back-ecf3f9 {
  background: #ecf3f9 !important;
}
.border-btn > .v-btn__content {
  justify-items: center;
  align-content: center;
  display: flex;
}

.back-f5f5f5 {
  background: #f5f5f5 !important;
}
</style>

<style scoped lang="scss">
.min-w-80 {
  min-width: 80px;
  font-size: 12px;
}
.v-text-field__details {
  display: none;
}

.min-w-70 {
  min-width: 70px;
}

.min-w-120 {
  min-width: 120px;
}
.color-blue {
  color: blue;
}

.color-red {
  color: red;
}

.v-btn:not(.v-btn--round).v-size--default {
  height: 50%;
}
.v-data-table--fixed-header.v-data-table--dense
  > .v-data-table__wrapper
  > table
  > thead {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 10;
}
.first-child1 {
  position: sticky;
  left: 0;
  z-index: 15 !important;
  min-width: 80px !important;
}
.first-child2 {
  position: sticky;
  left: 80px;
  min-width: 230px !important;
}
.first-child3 {
  position: sticky;
  left: 291px;
  z-index: 3;
}
table tbody th {
  position: sticky;
  left: 0;
  background: white;
  z-index: 1;
}
.min-w-100 {
  min-width: 100px;
}
.height-30 {
  height: 30px;
}

.v-input__slot {
  height: 36px !important;
}

.back-fbfbfb {
  background: #fbfbfb;
}

.back-fb {
  background: #fbfbfb;
  height: 100%;
}

.width100-height30 {
  width: 100px !important;
  height: 30px !important;
}

.width179-height41 {
  width: 179px;
  height: 41px !important;
}

.v-input__control {
  height: 41px !important;
}

.v-text-field {
  height: 32px !important;
}

.v-text-field.v-text-field--solo .v-input__control {
  min-height: 39px !important;
  margin: 0px;
}

.v-pagination__navigation {
  box-shadow: none !important;
  border: 1px solid #efefef;
}

.v-pagination__item {
  box-shadow: none !important;
  border: thin solid #efefef;
}

div.v-select-list div[role="list"] div[role="listitem"]:hover {
  background-color: #00857a;
}

.height-24 {
  height: 24px !important;
}
.cnt-td {
  min-width: fit-content;
  max-width: 120px;
}
.w-100 {
  min-width: 100px;
  max-width: 110px;
}
.floor-td {
  min-width: 80px;
  max-width: 110px;
}
.total-cnt-td {
  min-width: 100px;
  max-width: 120px;
}
</style>
